import { MARKER_ICONS } from '@/lib/markerIcons';

const BUS_FALLBACK = '<path d="M8 6v6M16 6v6M2 12h20M7 18h10M4 6h16v12H4z"/>';

/** 24x24 stroke SVG for a vehicle icon key; unknown/'custom' keys fall back to the bus glyph. */
export function markerSvg(iconKey) {
  const def = MARKER_ICONS.find((i) => i.key === iconKey);
  const body = def
    ? [...(def.paths || []).map((d) => `<path d="${d}"/>`), ...(def.circles || []).map((c) => `<circle cx="${c.cx}" cy="${c.cy}" r="${c.r}"/>`)].join('')
    : BUS_FALLBACK;
  return `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${body}</svg>`;
}
